import { render, staticRenderFns } from "./AdminViewModeToggle.vue?vue&type=template&id=46b1131a"
import script from "./AdminViewModeToggle.vue?vue&type=script&lang=js"
export * from "./AdminViewModeToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports